<template>
  <div>
    <highcharts :options="highChartOptions"></highcharts>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  props: {
    selectedDateRangeID: {
      type: String,
      default: 'current-month',
    }
  },
  data() {
    return {
      highChartOptions: {
        credits: {
          enabled: false
        },
        chart: {
          type: 'line'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
          type: 'day',
          dateTimeLabelFormats: {
            day: '%d/%m/%y'
          },
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        series: [],
        tooltip: {
          formatter: function() {
            return this.x + '<br>' + this.point.series.name + ' <b>' + window.accounting.formatMoney(this.y) + '</b>'
          }
        }
      },
    }
  },
  watch: {
    selectedDateRangeID() {
      this.get()
    }
  },
  computed: {
    ...mapGetters({
      config: 'config/config',
    })
  },
  mounted() {
    this.get()
  },
  methods: {
    get() {
      (async () => {
        let dateRange = this.$getDateRangeByIdentifier(this.selectedDateRangeID)

        const income = await axios.post('reports/payments/grouped', {
          from: dateRange.from.format(this.config.dateTimeFormats.api),
          to: dateRange.to.format(this.config.dateTimeFormats.api),
          type: 'income',
          group: 'day',
        })

        const expense = await axios.post('reports/payments/grouped', {
          from: dateRange.from.format(this.config.dateTimeFormats.api),
          to: dateRange.to.format(this.config.dateTimeFormats.api),
          type: 'expense',
          group: 'day',
        })

        Promise.all([income, expense])
          .then(values => {
            const incomeDataRaw = values[0].data
            const expenseDataRaw = values[1].data

            let labels = []
            incomeDataRaw.map(e => {
              labels.push(e.date_group)
            })
            expenseDataRaw.map(e => {
              for (let i in labels) {
                if (labels[i] === e.date_group) {
                  return
                }
              }
              labels.push(e.date_group)
            })
            labels.sort((a, b) => this.$moment(a, this.config.dateFormats.display) - this.$moment(b, this.config.dateFormats.display))


            let incomeData = []
            let expenseData = []
            for (let i in labels) {
              labels[i]
              let inc = incomeDataRaw.filter(e => e.date_group === labels[i])[0]
              let exp = expenseDataRaw.filter(e => e.date_group === labels[i])[0]
              incomeData.push(inc ? parseFloat(inc.total) : null)
              expenseData.push(exp ? parseFloat(exp.total) : null)
            }

            this.highChartOptions.xAxis.categories = labels
            this.highChartOptions.series = [
              {
                name: 'Income',
                data: incomeData,
                connectNulls: true,
              },
              {
                name: 'Expense',
                data: expenseData,
                connectNulls: true,
              }
            ]
          })

      })()
    },
  }
}
</script>
